import { createFileRoute } from '@tanstack/react-router';
import { JourneysSqlSyncImportHandoff } from '@/pages/workspaces/journeys/integrations/sql-sync/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/** The legacy `/journeys/integrations/sql-sync/:type/:id` URL: the embedded detail while the flag is off, a forward once it is on. */
function JourneysSqlSyncImportRoute() {
  const { type, sqlImportId } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSqlSyncImportHandoff type={type} sqlImportId={sqlImportId} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId',
)({
  component: JourneysSqlSyncImportRoute,
});
